import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import HeightBox from "../components/HeightBox";
import ActivityService from "../services/activityService";
import { WHITE } from "../colors";
import { CUSTOMER } from "../constants/userCategory";
import RemarkService from "../services/remarkService";
import MediaService from "../services/mediadocService";
import { Button } from "@mui/material";

export default function UserMediaFilesContainer({ userId, activityType, userRole }) {
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    activities: [],
    filteredActivities: [],
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const getPageInfo = async () => {
    setIsDataLoaded(true);
    // need to check customer or emplyee and get
    let res;
    if (userRole === CUSTOMER) {
      res = await MediaService.getAllMediaOfCustomer(userId);
    } else {
      res = await RemarkService.getAllRemarkOfEmployee(userId);
    }
    setScreenInfo({
      ...screenInfo,
      activities: res.data,
      filteredActivities: res.data,
    });
    setIsDataLoaded(false);
  };
  useEffect(() => {
    getPageInfo();
  }, []);

  const [mediaUrl,setMediaUrl]=useState([])

  const handleClick=async (fileName)=>{
    try {
      const mediaFile = await MediaService.getFileOfEmployee(fileName).then((res) => res.data);
      window.open(mediaFile, '_blank');
      setMediaUrl(mediaFile)
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (activityType && activityType !== "All") {
      setScreenInfo({
        ...screenInfo,
        filteredActivities: screenInfo.activities.filter((ac) => ac.type === activityType),
      });
    } else {
      setScreenInfo({
        ...screenInfo,
        filteredActivities: screenInfo.activities,
      });
    }
  }, [activityType]);
  return (
    <div>
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table
            sx={{
              minWidth: 650,

              backgroundColor: WHITE,
            }}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="left">Time</TableCell>
                <TableCell align="center">File Description</TableCell>
                <TableCell align="center">Submitted Employee</TableCell>
                <TableCell align="center">Media Type</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {screenInfo.filteredActivities?.map((row) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">{new Date(row.createdAt).toLocaleString()}</TableCell>

                  <TableCell align="center">{row.description?row.description:'Not added' }</TableCell>
                  <TableCell align="center">{row.Employee.name}</TableCell>

                  <TableCell align="center">{row.mediaType}</TableCell>
                  <TableCell align="center">  
                  <Button variant="contained" onClick={()=>handleClick(row.fileName)} without rel="noopener noreferrer" target="_blank" sx={{ backgroundColor: '#1976d2', color: '#ffffff', textTransform: 'none', borderRadius: '20px', padding: '5px 15px' }}>
                    Open File
                  </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
